<script lang="ts">
	import { Button } from '#lib/components/ui/button/index.js'
	import { phg } from '#lib/utils/posthog.js'
	import ChatGPT from '~icons/simple-icons/openai'

	let { class: className, prompt }: { class?: string; prompt: string } = $props()
</script>

<Button
	class={className}
	onclick={() => {
		phg.capture('open_in_ai', { ai: 'chatgpt' })
		window.open(
			`https://chatgpt.com?q=${encodeURIComponent(prompt)}`,
			'_blank',
			'noopener,noreferrer'
		)
	}}
	size="default"
	variant="outline"
>
	<ChatGPT />

	Open in ChatGPT
</Button>
